module.exports = __webpack_public_path__ + "img/ph-loa.e0d1b2d8.jpg";